import { DeepReadonly } from "@/utils";
import AWS from "aws-sdk";

const ENCODED_TOKEN =
  "QUtJQTQ2UUlVRUJRT1lKVElNU1U6d1ZXdGJzeXZWQVU4c3p4RWphcGEvVzQyWGRCSnY2U0Q5SUNlQmIvcA==";

export type CollectibleItemKey = {
  id: string;
};

export type CollectibleItemAttribute = {
  name: string;
  location: string;
  startHour1st: string;
  startHour2nd: string;
};

export type CollectibleFormItem = CollectibleItemKey &
  Partial<CollectibleItemAttribute>;
export type CollectibleItem = CollectibleItemKey & CollectibleItemAttribute;
export const StartHourList: DeepReadonly<string[]> = [
  "00-02",
  "02-04",
  "04-06",
  "06-08",
  "08-10",
  "10-12",
  "12-14",
  "14-16",
  "16-18",
  "18-20",
  "20-22",
  "22-00"
];

export function validate(form: CollectibleFormItem): CollectibleItem | null {
  if (form.name == null || form.name.length == 0) return null;
  if (form.location == null || form.location.length == 0) return null;
  if (form.startHour1st == null || !StartHourList.includes(form.startHour1st))
    return null;
  if (form.startHour2nd == null || !StartHourList.includes(form.startHour2nd))
    return null;
  return form as CollectibleItem;
}

type awsTokens = {
  access: string;
  secret: string;
};

function decodeToken(): awsTokens {
  const raw = atob(ENCODED_TOKEN);
  const part = raw.split(":");
  return {
    access: part[0],
    secret: part[1]
  };
}

export async function saveCollectibleItems(
  formItems: CollectibleFormItem[]
): Promise<boolean> {
  for (const item of formItems) {
    const tmp = validate(item);
    if (tmp == null) return false;
  }
  const tokens = decodeToken();
  const s3 = new AWS.S3({
    region: "ap-northeast-1",
    accessKeyId: tokens.access,
    secretAccessKey: tokens.secret
  });
  try {
    await s3
      .putObject({
        Bucket: "my.storage.luciferous.xyz",
        Key: "eorzea_collectibles.json",
        Body: JSON.stringify(formItems),
        ContentType: "application/json; charset=utf8"
      })
      .promise();
    return true;
  } catch (e) {
    return false;
  }
}

export async function loadCollectibleItems(): Promise<CollectibleItem[]> {
  const tokens = decodeToken();
  const s3 = new AWS.S3({
    region: "ap-northeast-1",
    accessKeyId: tokens.access,
    secretAccessKey: tokens.secret
  });

  try {
    const resp = await s3
      .getObject({
        Bucket: "my.storage.luciferous.xyz",
        Key: "eorzea_collectibles.json"
      })
      .promise();
    if (resp.Body == null) return [];
    const text = resp.Body.toString();
    return JSON.parse(text);
  } catch (e) {
    return [];
  }
}
